// @flow

import React, { Component, Fragment } from 'react';
import moment from 'moment';

import DaySummaryPlaceName from './DaySummaryPlaceName';
import DaySummaryServices from './DaySummaryServices';

import { makeUrlForLodgeCard } from '../utils';

import AddEntity from '../DayTrail/AddEntity';
import { withTrekEditInfo } from '../../../HOCs/withTrekEditInfo';
import withTrekPermission from '../../../HOCs/withTrekPermission';

type Props = {
  places: Array<String>,
  date: string,
  services: Array<String>,
  approx_day_cost: Object,
};

const LodgeAndFlight = ({ data, patchInfo, type, date, isFirst, modalType }) => {
  let component = null;
  if (data.length > 0) {
    component = data.map(card => {
      return (
        <Fragment key={card.id}>
          {type === 'flights' ? (
            <Fragment>
              <p>
                <span>Transportation: </span>
                <a href="/flights" target="_blank">
                  Filght from {`${card.name}`}.
                </a>
              </p>
            </Fragment>
          ) : type === 'lodges' ? (
            <Fragment>
              <p>
                <span>Accommodation: </span>
                <a
                  href={makeUrlForLodgeCard({
                    dayDate: date,
                    cardData: card,
                    patchInfo,
                    placeName: patchInfo.placeName,
                    isAdded: true,
                  })}
                >
                  {`${card.name}`}.
                </a>
              </p>
            </Fragment>
          ) : null}
          <AddEntity
            patchInfo={patchInfo}
            modalType={modalType}
            theme={type}
            text={`Add / Edit ${type}`}
            className="no-btn"
          />
        </Fragment>
      );
    });
  } else if (isFirst) {
    component = null;
  } else {
    component = (
      <Fragment>
        <p>
          <span>{type === 'flights' ? 'Transportation: ' : 'Accomodation: '}</span>
          <a>{'Not Selected.'}</a>
        </p>
        <AddEntity
          patchInfo={patchInfo}
          modalType={modalType}
          theme={type}
          text={`Add ${type}`}
          className="no-btn"
        />
        {type === 'flights' ? (
          <a href={`/${type}`} target="_blank">
            Search {type}
          </a>
        ) : null}
      </Fragment>
    );
  }
  if (component) {
    return <div className="trans-acco-holder"> {component} </div>;
  }
  return component;
};

class DaySummary extends Component<Props> {
  render() {
    const { date, places, data, roomType, region, modalType } = this.props;
    return (
      <div className="white-panel">
        <div className="row">
          <div className="col-12 day-summery">
            <div className="row">
              <div className="col-12 day-time mb-1">
                <p
                  className={'date float-left ' + (date ? ' ' : 'no-date')}
                  onClick={this.dateNotSelected}
                >
                  {date ? moment(date).format('MMMM DD, YYYY') : 'Date not selected'}
                </p>
              </div>
            </div>
            <div className="day-info clearfix">
              <ol>
                {places.map((place, i) => (
                  <DaySummaryPlaceName
                    key={`${place.id}+${i}`}
                    place={place}
                    region={region}
                  />
                ))}
              </ol>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-12">
            <hr id="mod" />
            <LodgeAndFlight
              data={data.flightInfoInSummary}
              patchInfo={data.patchInfoFlight}
              type="flights"
              isFirst={data.isFirst}
              date={date}
              modalType={modalType}
            />
            <LodgeAndFlight
              data={data.lodgeInfoInSummary}
              patchInfo={data.patchInfoLodge}
              type="lodges"
              date={date}
              modalType={modalType}
            />
            <ul className="facility-list clearfix">
              {data.lodgeInfoInSummary &&
                data.lodgeInfoInSummary.map(lodge => (
                  <DaySummaryServices
                    key={lodge.id}
                    services={
                      lodge.included_services ? lodge.included_services[roomType] : ''
                    }
                  />
                ))}
            </ul>

            <p className="per-day-price">
              <span>
                {/* <span>{`${approx_day_cost.amount} ${approx_day_cost.unit}`}</span> */}
              </span>
            </p>
          </div>
        </div>
      </div>
    );
  }
  dateNotSelected = () => {
    const { edit, toggle, date } = this.props;
    if (!date) {
      // if (edit.edit) setTimeout(() => edit.edit({ message: edit.message }), 500);
      ///close modal after the edit notification is toggled or do not open it at all
      if (edit.edit) setTimeout(() => edit.edit({ message: edit.message }), 500);
      else toggle();
    } else return null;
  };
}

export default withTrekPermission(withTrekEditInfo(DaySummary));



// WEBPACK FOOTER //
// ./src/screens/Trek/DaySummary/DaySummary.js